module.exports = __webpack_public_path__ + "img/server4.1c33f5f7.svg";